import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { PRComponiFatturaConfirmComponent } from './pr-componi-fattura-confirm';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.pr-componi-fattura-confirm', {
            url: '/pr-componi-fattura-confirm',
            ncyBreadcrumb: {
                label: 'Componi Fattura Conferma',
                parent: 'home.fatturazione-pr'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Componi Fattura Conferma'
            },
            'views': {
                'homeContent': {
                    template: '<pr-componi-fattura-confirm flex="100"></pr-componi-fattura-confirm>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const PRComponiFatturaConfirmModule: string = ng
    .module('pr-componi-fattura-confirm', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('prComponiFatturaConfirm', PRComponiFatturaConfirmComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/pr-componi-fattura-confirm/pr-componi-fattura-confirm.module.ts